<template>
  <div :class="{
    '_top': top,
    '_bottom': bottom,
  }"
       @scroll="onCheck">
    <slot :top="top"
          :bottom="bottom">
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'ScrollView',
    data() {
      return {
        top: false,
        bottom: false,
      }
    },
    methods: {
      onCheck() {
        const $el = this.$el
        if (!$el) return

        const scrollTop = $el.scrollTop

        if (scrollTop === 0) {
          this.top = true
          this.bottom = false
          return
        }

        const maxScroll = $el.scrollHeight - $el.offsetHeight

        if (scrollTop === maxScroll) {
          this.top = false
          this.bottom = true
          return
        }

        this.top = false
        this.bottom = false
      },
    },
    mounted() {
      this.onCheck()
    },
  }
</script>

<style lang="less">

</style>
